import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import Modal from "~/components-shared/Modal";
import { Badge, Box, Card, Grid, Icon, Link, Spinner, Text } from "~/components-shared";
import { truncatedContent } from "~/lib/helpers";
import api from "~/lib/api";
import { RoutesEnum } from "~/types/enums";
import moment from "moment";
const StyledButton = styled(Button)`
  & span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const StyledGrid = styled(Grid)`
  border-radius: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.shape.borderRadius.primary;
}};
`;
const TopicSummaryRevenueCardModal = _ref2 => {
  let {
    opportunity,
    onClose
  } = _ref2;
  const {
    t
  } = useTranslation();
  const [linkedTopics, setLinkedTopics] = useState(undefined);
  const [linkedTopicsLoading, setLinkedTopicsLoading] = useState(false);
  const handleOpenMemberProfile = url => {
    !!url && window.open(url, "_blank");
  };
  const handleTopicClick = topicId => {
    const url = `${window.location.origin}${RoutesEnum.TOPIC.replace(":topicId", topicId)}?view=footprints`;
    window.open(url, "_blank");
  };
  useEffect(() => {
    if (opportunity) {
      setLinkedTopicsLoading(true);
      api.sourceIdLinkedTopics(opportunity.id).then(data => setLinkedTopics(data));
      setLinkedTopicsLoading(false);
    }
  }, [opportunity]);
  if (!opportunity) {
    return null;
  }
  const {
    name,
    url,
    stage,
    probability,
    amount,
    currency,
    closeDate,
    owner,
    account,
    customFields
  } = opportunity;
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: name,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "700px"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 3.5
  }, "Salesforce", " ", /*#__PURE__*/React.createElement(Link, {
    href: url,
    underline: true
  }, t("TopicSummaryRevenueModal.opportunity")), " ", owner.name.length && owner.url && /*#__PURE__*/React.createElement(Text, null, t("TopicSummaryRevenueModal.ownedBy"), " ", /*#__PURE__*/React.createElement(Link, {
    href: owner.url,
    underline: true
  }, owner.name), " ")), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold",
    s: {
      mt: 4
    }
  }, !!amount && /*#__PURE__*/React.createElement(Badge, {
    color: "infoGrey",
    display: "inline-block",
    fontSize: 3.5,
    s: {
      py: 1.5,
      px: 3.5,
      mr: 2,
      mt: -0.5,
      mb: 2
    },
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": "<div>Associated Revenue</div>",
    style: {
      cursor: "help",
      textDecoration: "underline dotted"
    }
  }, currency, amount.toLocaleString("en-US")), /*#__PURE__*/React.createElement(Badge, {
    color: "grey",
    display: "inline-block",
    fontSize: 3.5,
    s: {
      py: 1.5,
      px: 3.5,
      mr: 2,
      mt: -0.5,
      mb: 2
    }
  }, stage, !!probability && ` | ${probability.toFixed(0)}%`), !!closeDate && /*#__PURE__*/React.createElement(Badge, {
    color: "grey",
    display: "inline-block",
    fontSize: 3.5,
    s: {
      py: 1.5,
      px: 3.5,
      mr: 2,
      mt: -0.5,
      mb: 2
    }
  }, t("TopicSummaryRevenueModal.closeDate"), ": ", moment(closeDate).format("MMM Do YYYY"))), !!customFields?.length && /*#__PURE__*/React.createElement(Card, {
    color: "translucent",
    s: {
      mt: 2
    }
  }, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4.5,
    s: {
      px: 1,
      py: 0
    },
    align: "stretch"
  }, customFields.map(field => /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    s: {
      mb: 1
    }
  }, field.label), field.type === "textarea" && field.value.toString().length > 20 ? /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<div>${field.value}</div>`
  }, truncatedContent(field.value.toString(), 20)) : /*#__PURE__*/React.createElement(Text, {
    display: "block",
    weight: "bold",
    fontSize: 3.5
  }, field.value, field.type === "percent" && "%"))))), !!account?.name && !!account.url && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textPrimary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      mt: 6
    }
  }, t("TopicSummaryRevenueModal.relatedAccount"), ":"), /*#__PURE__*/React.createElement(Card, {
    color: "transparent",
    border: true,
    s: {
      mt: 2
    }
  }, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 3,
    s: {
      px: 1,
      py: 0
    },
    align: "stretch"
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    s: {
      mb: 2
    }
  }, "Company"), /*#__PURE__*/React.createElement(Link, {
    href: account.url,
    color: "text",
    display: "inline-block",
    weight: "bold",
    fontSize: 3.5,
    underline: true
  }, account.name)), !!account.industry && /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    s: {
      mb: 2
    }
  }, "Industry"), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    weight: "bold",
    fontSize: 3.5
  }, account.industry)), !!account?.annualRevenue && /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    s: {
      mb: 2
    }
  }, "Annual Revenue"), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    weight: "bold",
    fontSize: 3.5
  }, currency, account.annualRevenue.toLocaleString()))))), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textPrimary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      mt: 6
    }
  }, t("TopicSummaryRevenueModal.mappedTopics"), ":"), linkedTopicsLoading ? /*#__PURE__*/React.createElement(Spinner, {
    scale: 6,
    s: {
      mt: 3
    }
  }) : linkedTopics ? /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    direction: "column",
    s: {
      mt: 3
    }
  }, linkedTopics.map(topic => /*#__PURE__*/React.createElement(StyledButton, {
    key: topic.id,
    onClick: () => handleTopicClick(topic.id),
    fontSize: 3.5,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": topic.name,
    s: {
      px: 2,
      py: 1
    },
    maxWidth: "200px",
    color: "primaryGrey"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "timelapse",
    s: {
      mr: 1,
      mt: -0.5
    }
  }), topic.name))) : /*#__PURE__*/React.createElement(Badge, {
    color: "dangerGrey"
  }, t("TopicSummaryRevenueModal.notMapped"))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Link, {
    href: opportunity.url,
    s: {}
  }, /*#__PURE__*/React.createElement(Button, {
    color: "greyTransparent",
    s: {
      mr: 2
    },
    fullWidth: true,
    rounded: true
  }, t("TopicSummaryRevenueModal.viewInSalesforce"))), owner.url?.length && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "180px",
    onClick: () => handleOpenMemberProfile(owner.url),
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("TopicSummaryRevenueModal.contactOwner"))));
};
export default TopicSummaryRevenueCardModal;